import { Box } from '@rbilabs/universal-components';

export const MapContainer = Box.withConfig({
  flex: 1,
});
